import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { PublicLayout } from "./components/site/PublicLayout";
import Home from "./pages/Home";
import GroupTours from "./pages/GroupTours";
import FamilyTours from "./pages/FamilyTours";
import TourDetail from "./pages/TourDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Policy, { NotFound } from "./pages/Policy";
import { AuthProvider, RequireAdmin } from "./admin/AuthContext";
import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";
import AdminTours from "./admin/AdminTours";
import TourEditor from "./admin/TourEditor";
import AdminInquiries from "./admin/AdminInquiries";
import AdminContent from "./admin/AdminContent";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/group-tours" element={<GroupTours />} />
            <Route path="/group-tours/:slug" element={<TourDetail />} />
            <Route path="/family-tours" element={<FamilyTours />} />
            <Route path="/family-tours/:slug" element={<TourDetail />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/privacy-policy" element={<Policy />} />
            <Route path="/terms-and-conditions" element={<Policy />} />
            <Route path="/cancellation-policy" element={<Policy />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<RequireAdmin><AdminLayout /></RequireAdmin>}>
            <Route index element={<AdminTours />} />
            <Route path="tours/new" element={<TourEditor />} />
            <Route path="tours/:slug" element={<TourEditor />} />
            <Route path="inquiries" element={<AdminInquiries />} />
            <Route path="content" element={<AdminContent />} />
          </Route>
        </Routes>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
